import { HttpHandler } from 'msw'

import { products } from './products'

export const catalogue: HttpHandler[] = [...products]
